import React from 'react';
import { Check, Package, Truck, Home, Sparkles } from 'lucide-react';

const STAGES = [
  { key: 'Order Received', label: 'Order Received', icon: Sparkles, description: 'We received your order and payment' },
  { key: 'Being Prepared', label: 'Being Prepared', icon: Package, description: 'Handpicking A-Grade stems from the farm' },
  { key: 'Out for Delivery', label: 'Out for Delivery', icon: Truck, description: 'On the way to your doorstep' },
  { key: 'Delivered', label: 'Delivered', icon: Home, description: 'Enjoy your beautiful lilies!' },
];

const getStageIndex = (status) => {
  const idx = STAGES.findIndex(s => s.key === status);
  return idx >= 0 ? idx : 0;
};

export const OrderTimeline = ({ status = 'Order Received' }) => {
  const currentIdx = getStageIndex(status);

  return (
    <div className="w-full" data-testid="order-timeline">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6 sm:gap-2">
        {STAGES.map((stage, idx) => {
          const Icon = stage.icon;
          const isDone = idx < currentIdx;
          const isCurrent = idx === currentIdx;

          let iconWrapperClass = 'bg-brand-cream border border-brand-gold/40 text-brand-gold/40';
          if (isDone) {
            iconWrapperClass = 'bg-brand-green text-brand-cream';
          } else if (isCurrent) {
            iconWrapperClass = 'bg-brand-gold text-brand-green-dark ring-4 ring-brand-gold/30 animate-pulse';
          }

          return (
            <React.Fragment key={stage.key}>
              <div className="flex sm:flex-col items-center sm:items-center gap-4 sm:gap-3 flex-1" data-testid={`timeline-stage-${idx}`}>
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 smooth-transition ${iconWrapperClass}`}
                >
                  {isDone ? (
                    <Check className="w-5 h-5" strokeWidth={2} />
                  ) : (
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  )}
                </div>
                <div className="sm:text-center flex-1 sm:flex-initial">
                  <p
                    className={`font-body text-sm font-bold uppercase tracking-wider ${
                      isDone || isCurrent ? 'text-brand-green-dark' : 'text-brand-green-dark/40'
                    }`}
                  >
                    {stage.label}
                  </p>
                  <p
                    className={`font-body text-xs mt-1 ${
                      isDone || isCurrent ? 'text-brand-green-dark/70' : 'text-brand-green-dark/30'
                    }`}
                  >
                    {stage.description}
                  </p>
                </div>
              </div>

              {idx < STAGES.length - 1 && (
                <div className="hidden sm:block h-px bg-brand-gold/30 flex-1 mt-6" />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
